import { render, staticRenderFns } from "./addServer.vue?vue&type=template&id=149543e7&scoped=true&"
import script from "./addServer.vue?vue&type=script&lang=js&"
export * from "./addServer.vue?vue&type=script&lang=js&"
import style0 from "./addServer.vue?vue&type=style&index=0&id=149543e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149543e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('149543e7')) {
      api.createRecord('149543e7', component.options)
    } else {
      api.reload('149543e7', component.options)
    }
    module.hot.accept("./addServer.vue?vue&type=template&id=149543e7&scoped=true&", function () {
      api.rerender('149543e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/banUser/components/addServer.vue"
export default component.exports